import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useState } from "react";

interface AvatarPreviewDialogProps {
  src: string;
  alt: string;
  fallback?: string;
  className?: string;
}

export const AvatarPreviewDialog = ({ src, alt, fallback, className }: AvatarPreviewDialogProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Avatar className={className} onClick={() => setOpen(true)} style={{ cursor: 'pointer' }}>
        <AvatarImage src={src} alt={alt} />
        {fallback && <AvatarFallback>{fallback}</AvatarFallback>}
      </Avatar>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl p-0 bg-transparent border-0 shadow-none" onClick={() => setOpen(false)}>
          <div className="relative w-full aspect-square">
            <img 
              src={src} 
              alt={alt}
              className="w-full h-full object-contain rounded-lg cursor-pointer"
              style={{ imageRendering: 'auto' }}
              onClick={() => setOpen(false)}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
